const EMAIL_VERIFICATION_CODE_LENGTH =
  parseInt(process.env.EMAIL_VERIFICATION_CODE_LENGTH, 10) || 6;
const MIN_PASSWORD_LENGTH = parseInt(process.env.MIN_PASSWORD_LENGTH, 10) || 5;

const ENGLISH = 'en';
const GERMAN = 'de';
const PORTUGUESE = 'pt';
const FRENCH = 'fr';
const SPANISH = 'es';
const ITALIAN = 'it';
const LANGUAGES = [ENGLISH, GERMAN, PORTUGUESE, FRENCH, SPANISH, ITALIAN];

const LANGUAGES_MAP = {
  [ENGLISH]: {
    base: true,
  },
  [GERMAN]: {
    base: true,
  },
  [PORTUGUESE]: {
    base: true,
    poName: 'pt-br',
  },
  [FRENCH]: {},
  [SPANISH]: {},
  [ITALIAN]: {},
};

module.exports = {
  EMAIL_VERIFICATION_CODE_LENGTH,
  MIN_PASSWORD_LENGTH,
  // The available languages, sorted by descending priority.
  // Currently if the user does not explicitly request German ('de', 'de-DE', 'de-CH' etc),
  // we will use English as fallback.
  LANGUAGES,
  LANGUAGES_MAP,
  BASE_LANGUAGES: LANGUAGES.filter((lang) => LANGUAGES_MAP[lang].base),
  WHATSAPP_FEEDBACK_NUMBER: '+4915792453454',
  FEEDBACK_EMAIL: 'support@lootboy.de',
  LIB_VERSION: '0.1.0',
  TRIAL_CARD_TEMPLATE_ID: '5d5d76734fb035001c4427c0',
  CARDS_FETCH_LIMIT: 5000,
  ENGLISH,
  GERMAN,
  FRENCH,
  PORTUGUESE,
  SPANISH,
  ITALIAN,
};
